import { render, staticRenderFns } from "./paperworkFile.vue?vue&type=template&id=59db5e30&scoped=true"
import script from "./paperworkFile.vue?vue&type=script&lang=js"
export * from "./paperworkFile.vue?vue&type=script&lang=js"
import style0 from "./paperworkFile.vue?vue&type=style&index=0&id=59db5e30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db5e30",
  null
  
)

export default component.exports